import { Box, Button, IconButton, InputAdornment, MenuItem, Select, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';
import { useLocation, useNavigate } from 'react-router-dom';
import icon_delete from '../../assets/icons/delete.svg'
import * as api from '../services/api'
import Loader from 'components/Loader';

function InterpretationEdit() {
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const ref = useRef([])

    const [healthcheckName, setHealthcheckName] = useState('')

    const [checklistCode, setChecklistCode] = useState('')
    const [checklistName, setChecklistName] = useState('')
    const [optionChecklist, setOptionChecklist] = useState([])

    const [field, setField] = useState('')

    const [optionOperation, setOptionOperation] = useState([])
    const [optionConditions, setOptionConditions] = useState([])
    const [optionGender, setOptionGender] = useState([])
    const [optionAge, setOptionAge] = useState([])
    const [optionGroup, setOptionGroup] = useState([
        'ปกติ',
        'เสี่ยง',
        'ผิดปกติ',
        'พบแพทย์ด่วน',
        'เป็นโรค',
        'ต่ำกว่าเกณฑ์',
        'ต่ำ',
        'สูง',
        'น้ำหนักต่ำกว่าเกณฑ์',
        'สมส่วน',
        'น้ำหนักเกิน',
        'โรคอ้วน',
        'โรคอ้วนอันตราย'
    ])

    const [interpret, setInterpret] = useState(null)
    const [conditions, setConditions] = useState([{
        healthcheck_code: "",
        line_number: "",
        color: "#000000",
        group: null,
        result: "",
        recommend: "",
        gender: "ALL",
        age: "ALL",
        condition: "-",
        operation: "NONE",
        operation2: "NONE",
        value: "",
        value2: "",
        unit: ""
    }])

    useEffect(() => {
        operation()
        condition()
        genderCriteria()
        age()
    }, [])

    useEffect(() => {

        let data = location.state
        setOptionChecklist(data['option'])
        setInterpret(data['list'])

        console.log(data['option'])

        setChecklistCode(data['list']['checklist_group_code'])
        setChecklistName(data['list']['checklist_group_name'])
        setField(data['list']['field'])
        setConditions(data['list']['condition_list'])
        setHealthcheckName(data['list']['healthcheck_name'])
    }, [])

    const operation = async () => {
        setLoading(true)
        let res = await api.operation()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']
                setOptionOperation(data)
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const condition = async () => {
        setLoading(true)
        let res = await api.condition()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']
                setOptionConditions(data)
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const genderCriteria = async () => {
        setLoading(true)
        let res = await api.genderCriteria()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']
                setOptionGender(data)
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const age = async () => {
        setLoading(true)
        let res = await api.age()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']
                setOptionAge(data)
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const updateCriteria = async (body) => {
        setLoading(true)
        let res = await api.updateCriteria(body)
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                //alert(res['data']['message']);
                navigate('/manageProcessing')
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const handleClickAddRules = () => {
        conditions.push({
            color: "#000000",
            group: null,
            result: "",
            recommend: "",
            gender: "ALL",
            age: "ALL",
            condition: "-",
            operation: "NONE",
            operation2: "NONE",
            value: "",
            value2: "",
            unit: ""
        })
        setConditions([...conditions])
    }

    const handleChangeConditions = (e, idx, name) => {
        let newConditions = [...conditions];
        newConditions[idx][name] = e.target.value;
        setConditions(newConditions);
    }

    const handleClickRemoveRules = (i) => {
        conditions.splice(i, 1)
        setConditions([...conditions])
    }

    const handleClickSave = () => {
        const updatedData = conditions.map(item => {
            if (item.condition === "-" || item.condition === "") {
                return { ...item, value2: "-", operation2: "NONE" };
            }
            return item;
        });

        let data = addSequentialIndex(updatedData)
        // let data = addSequentialIndex(conditions)
        let boby = {
            "healthcheck_code": interpret['healthcheck_code'],
            "healthcheck_name": healthcheckName,
            "field": interpret['healthcheck_name'],
            "checklist_group_code": checklistCode,
            "doc_status": interpret['doc_status'],
            "remark": interpret['remark'],
            "checklist_group_name": checklistName,
            "condition_list": data
        }
        // console.log(boby)
        updateCriteria(boby)
    }

    const addSequentialIndex = (array, start = 1) => {
        return array.map((item, i) => ({
            ...item,
            line_number: i + start,
            healthcheck_code: interpret['healthcheck_code']
        }));
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/manageProcessing') }}
                    >กลับไป จัดการเกณฑ์แปลผล</Box>
                </Box>

                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>แก้ไข {interpret?.['healthcheck_name']}</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '20px',
                }}>
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gridGap: '20px',
                        "@media (max-width: 800px)": {
                            padding: '10px',
                            gridTemplateColumns: '1fr',
                            gridGap: '10px'
                        },
                    }}>
                        <Box>
                            <Box sx={{ fontWeight: 500 }}>ชื่อชีทที่ผูกเกณฑ์</Box>
                            <Select
                                size="small"
                                fullWidth
                                value={checklistCode || 'null'}
                                onChange={(e) => {
                                    let { value } = e.target
                                    setChecklistCode(value)

                                    let selected = optionChecklist.find(item => item.key === value);
                                    setChecklistName(selected.name);
                                }}
                            >
                                <MenuItem value={'null'} disabled>ชื่อชีทที่ผูกเกณฑ์</MenuItem>
                                {optionChecklist.map((i, idx) => (
                                    <MenuItem key={idx} value={i['key']}>{i['name']}</MenuItem>
                                ))}
                            </Select>
                        </Box>
                        <Box>
                            <Box sx={{ fontWeight: 500 }}>ชื่อคอลัมน์ที่ผูกเกณฑ์ (พิมพ์ให้ตรงกับชื่อคอลัมน์ในไฟล์นำเข้า)</Box>
                            <TextField
                                size="small"
                                fullWidth
                                value={field}
                                // onChange={(e) => { setField(e.target.value) }}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                    <Box>
                        <Box sx={{ fontWeight: 500 }}>ชื่อค่าที่ใช้แสดงผล (ภาษาไทย/ อังกฤษ)</Box>
                        <TextField
                            size="small"
                            fullWidth
                            value={healthcheckName}
                            onChange={(e) => { setHealthcheckName(e.target.value) }}
                        />
                    </Box>
                </Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '20px',
                    "@media (max-width: 800px)": {
                        padding: '10px',
                        gridGap: '10px'
                    },
                }}>
                    <Box sx={{ textAlign: 'center', color: '#478F96', fontWeight: 600 }}>เงื่อนไขในการแปลผล</Box>

                    {conditions.map((item, index) => (
                        <React.Fragment key={index}>
                            <Box sx={{
                                color: '#478F96',
                                fontWeight: 600,
                                display: 'flex',
                                gridGap: '10px'
                            }}>
                                <Box>เงื่อนไขที่ {index + 1}</Box>
                                {conditions.length > 1 &&
                                    <img
                                        style={{ width: '17px', cursor: 'pointer' }}
                                        src={icon_delete}
                                        onClick={() => { handleClickRemoveRules(index) }}
                                    />
                                }
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '10px'
                                },
                            }}>
                                <Box>
                                    <Box>ระบุค่า</Box>
                                    <Select
                                        size="small"
                                        placeholder='it[6'
                                        fullWidth
                                        value={item['operation'] || 'null'}
                                        onChange={(event) => { handleChangeConditions(event, index, 'operation') }}
                                    >
                                        <MenuItem value={'null'} disabled >เลือกระบุค่า</MenuItem>
                                        {optionOperation.map((i, idx) => (
                                            <MenuItem key={idx} value={i['name']} >{i['value']}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                                <Box>
                                    <Box>กรอกค่า</Box>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        value={item['value']}
                                        onChange={(event) => { handleChangeConditions(event, index, 'value') }}
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Box>เลือกตัวเชื่อมเกณฑ์ <span style={{ color: '#9D9B9B' }}>และ, หรือ (ถ้ามี)</span></Box>
                                <Select
                                    size="small"
                                    fullWidth
                                    value={item['condition'] || '-'}
                                    onChange={(event) => { handleChangeConditions(event, index, 'condition') }}
                                >
                                    {optionConditions.map((i, idx) => (
                                        <MenuItem key={idx} value={i['name']} >{i['value']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '10px'
                                },
                            }}>
                                <Box>
                                    <Box>ระบุค่าเทียบ (กรณีเลือกตัวเชื่อมเกณฑ์เป็น และ/ หรือ)</Box>
                                    <Select
                                        size="small"
                                        fullWidth
                                        value={item['operation2'] || 'null'}
                                        onChange={(event) => { handleChangeConditions(event, index, 'operation2') }}
                                        disabled={item['condition'] == '-' || item['condition'] == '' ? true : false}
                                        sx={item['condition'] == '-' || item['condition'] == '' ? { background: '#E5E5E5' } : ''}
                                    >
                                        <MenuItem value={'null'} disabled >เลือกระบุค่า</MenuItem>
                                        {optionOperation.map((i, idx) => (
                                            <MenuItem key={idx} value={i['name']} >{i['value']}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                                <Box>
                                    <Box>กรอกค่า</Box>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        value={item['value2']}
                                        onChange={(event) => { handleChangeConditions(event, index, 'value2') }}
                                        disabled={item['condition'] == '-' || item['condition'] == '' ? true : false}
                                        sx={item['condition'] == '-' || item['condition'] == '' ? { background: '#E5E5E5' } : ''}
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Box>หน่วย</Box>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={item['unit']}
                                    onChange={(event) => { handleChangeConditions(event, index, 'unit') }}
                                />
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '10px'
                                },
                            }}>
                                <Box>
                                    <Box>ข้อความการแปลผล</Box>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        value={item['result']}
                                        onChange={(event) => { handleChangeConditions(event, index, 'result') }}
                                    />
                                </Box>
                                <Box>
                                    <Box>การจัดกลุ่ม</Box>
                                    <Select
                                        size="small"
                                        fullWidth
                                        value={item['group'] || 'null'}
                                        onChange={(event) => { handleChangeConditions(event, index, 'group') }}
                                    >
                                        <MenuItem value={'null'} disabled>เลือกการจัดกลุ่ม</MenuItem>
                                        {optionGroup.map((i, idx) => (
                                            <MenuItem key={idx} value={i} >{i}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            </Box>


                            <Box>
                                <Box>คำแนะนำ/ คำอธิบายการแปลผล</Box>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={item['recommend']}
                                    onChange={(event) => { handleChangeConditions(event, index, 'recommend') }}
                                />
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '10px'
                                },
                            }}>
                                <Box>
                                    <Box sx={{ fontWeight: 500 }}>ใช้กับเพศใด (ถ้ามี)</Box>
                                    <Select
                                        size="small"
                                        fullWidth
                                        value={item['gender'] || 'ALL'}
                                        onChange={(event) => { handleChangeConditions(event, index, 'gender') }}
                                    >
                                        {optionGender.map((i, idx) => (
                                            <MenuItem key={idx} value={i['name']} >{i['value']}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                                <Box>
                                    <Box sx={{ fontWeight: 500 }}>ใช้กับช่วงอายุใด (ถ้ามี)</Box>
                                    <Select
                                        size="small"
                                        fullWidth
                                        value={item['age'] || 'ALL'}
                                        onChange={(event) => { handleChangeConditions(event, index, 'age') }}
                                    >
                                        {optionAge.map((i, idx) => (
                                            <MenuItem key={idx} value={i['name']} >{i['value']}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '10px'
                                },
                            }}>
                                <Box>
                                    <Box>เลือกสีที่ใช้ในการแสดงผล</Box>
                                    <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                        <input
                                            type="color"
                                            value={item['color']}
                                            ref={el => ref.current[index] = el}
                                            onChange={(event) => { handleChangeConditions(event, index, 'color') }}
                                        />
                                        <TextField
                                            size='small'
                                            fullWidth
                                            value={item['color']}
                                            onChange={(event) => { handleChangeConditions(event, index, 'color') }}
                                            InputProps={{
                                                // inputProps: {
                                                //     readOnly: true,
                                                // },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <label
                                                            style={{ display: 'flex' }}
                                                            onClick={() => { ref.current[index].click() }}
                                                        >
                                                            <ColorLensOutlinedIcon style={{ cursor: 'pointer' }} />
                                                        </label>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />

                                    </Box>
                                </Box>
                                <Box></Box>
                            </Box>

                            {conditions.length > 1 &&
                                <Box sx={{ borderTop: '1px solid #9D9B9B' }}></Box>
                            }
                        </React.Fragment>
                    ))}

                    <Box sx={{ textAlign: 'center' }}>
                        <Button variant='contained' onClick={() => { handleClickAddRules() }}>เพิ่มกฏ</Button>
                    </Box>
                </Box>

                <Box sx={{ textAlign: 'end', padding: '10px 0' }}>
                    <Button
                        variant='contained'
                        sx={{ width: '100px' }}
                        onClick={() => { handleClickSave() }}
                    >บันทึก</Button>
                </Box>
            </Box>
        </>
    )
}

export default InterpretationEdit